exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grow[data-v-f2483780]:hover {\n  transform: scale(1.15);\n}\n.preview-btn[data-v-f2483780] {\n  padding: 0.45rem;\n  background: transparent;\n  border-style: solid;\n  border-width: 1px;\n}\n", ""]);

// exports
